const FilterConstants = {
  filterType: {
    lowPass: 'lowPass',
    highPass: 'highPass',
    bandPass: 'bandPass',
    bandStop: 'bandStop',
    gain: 'gain',
    notch: 'notch',
  },
  optimizationType: {
    noise: 'Noise',
    voltageRange: 'VoltageRange',
    power: 'Power',
    recommendedSpecific: 'RecommendedSpecificComponents',
    allowedSpecific: 'AllowedSpecificComponents',
  },
  optimizationPreferenceOptions: {
    specific: 'specific',
    nonSpecific: 'nonSpecific',
  },
  responseType: {
    bessel: 'Bessel',
    chebyshev: 'Chebyshev',
    butterworth: 'Butterworth',
    butterworthBessel: 'Butterworth Bessel',
  },
  sizing: {
    big: 'big',
    tiny: 'tiny',
  },
  gainUnits: {
    vv: 'V/V',
    db: 'dB',
  },
  idealOpAmp: 'ideal',
  tabs: {
    filterType: 'filterType',
    specifications: 'specifications',
    components: 'components',
    tolerances: 'tolerances',
    nextSteps: 'nextSteps',
  },
  fields: {
    inputs: {
      specifications: {
        gain: 'gain',
        gainUnit: 'gainUnit',
        passbandFrequency: 'passbandFrequency',
        passbandAttenuation: 'passbandAttenuation',
        stopbandFrequency: 'stopbandFrequency',
        stopbandAttenuation: 'stopbandAttenuation',
        centerFrequency: 'centerFrequency',
      },
      components: {
        vsPlus: 'vsPlus',
        vsMinus: 'vsMinus',
      },
    },
  },
  figureName: {
    magnitudeDb: 'magnitudeDb',
    magnitudeVV: 'magnitudeVV',
    phaseDegrees: 'phaseDegrees',
    phaseRadians: 'phaseRadians',
    phaseDelay: 'phaseDelay',
    groupDelay: 'groupDelay',
    stepResponse: 'stepResponse',
    stages: 'stages',
    inputImpedanceMagnitude: 'inputImpedanceMagnitude',
    inputImpedancePhase: 'inputImpedancePhase',
    noise: 'noise',
    power: 'power',
    voltageRange: 'voltageRange',
    circuit: 'circuit',
    billOfMaterials: 'billOfMaterials',
  },
  Limits: {
    RSMALL_LOAD_LIMIT: 50,
    RSMALL_COMP_LIMIT: 1,
    RBIG_COMP_LIMIT: 10e6,
    CSMALL_COMP_LIMIT: 1e-11,
    CBIG_COMP_LIMIT: 1e-5,
    LSMALL_COMP_LIMIT: 1e-9,
    LBIG_COMP_LIMIT: 33e-6,
    REFERENCE_OPAMP_MAX_VOLTAGE: 12,
    REFERENCE_OPAMP_MIN_VOLTAGE: 2.7,
    INFINITY: 1e66,
    NEARLY_INFINITY: 1e40,
    NEGINFINITY: -1e60,
    REFERENCE_OPAMP_CURRENT: 0.0014,
    REFERENCE_RESISTOR: 10000,
    INDUCTOR_ALLOWED_FREQ: 1e6,
    INDUCTOR_PREFERRED_FREQ_X_GAIN_X_Q: 20e6,
    INDUCTOR_REQUIRED_FREQ_X_GAIN_X_Q: 20e6,
    PARASITIC_INPUT_CAP: 3e-12,
  },
  solutionPossibleType: {
    solutionExists: 'Solution Exists',
    frequencyTooHigh: 'Frequency too high',
    frequencyTooLow: 'Frequency too low',
  },
  implementationType: {
    sallenKey: 'sallenKey',
    deliyannisFriend: 'deliyannisFriend',
    firstOrder: 'firstOrder',
    multipleFeedback: 'multipleFeedback',
    inductor: 'inductor',
    gain: 'gain',
  },
  model: {
    inputs: {
      components: {
        defaultAlgorithm: {
          'sallenKey|lowPass': 'lowpassV2',
        },
        oldAlgorithm: {
          'sallenKey|lowPass': 'lowpass',
        },
      },
    },
  },
  noiseSources: {
    r1: 'R1',
    r2: 'R2',
    r3: 'R3',
    r4: 'R4',
    r5: 'R5',
    r6: 'R6',
    opAmpVoltage: 'OpAmpVoltage',
    opAmpNegCurrent: 'OpAmpNegCurrent',
    opAmpPosCurrent: 'OpAmpPosCurrent',
  },
  resistorTolerance: {
    ideal: 'ideal',
    oneTenth: '0.1%',
    fiveTenths: '0.5%',
    one: '1%',
    five: '5%',
  },
  capacitorTolerance: {
    ideal: 'ideal',
    one: '1%',
    five: '5%',
    ten: '10%',
    twenty: '20%',
  },
  inductorTolerance: {
    ideal: 'ideal',
    five: '5%',
    ten: '10%',
    twenty: '20%',
  },
  gbwTolerance: {
    ideal: 'ideal',
    twenty: '20%',
  },
  eSeries: {
    E6: 'E6',
    E12: 'E12',
    E24: 'E24',
    E48: 'E48',
    E96: 'E96',
    ideal: 'ideal',
  },
  resistorNames: {
    r1: 'R1',
    r2: 'R2',
    r3: 'R3',
    r4: 'R4',
    r5: 'R5',
    r6: 'R6',
  },
  capacitorNames: {
    c1: 'C1',
    c2: 'C2',
    c3: 'C3',
    c4: 'C4',
    c5: 'C5',
  },
  bypassCapacitorNames: {
    c9: 'C9',
    c0: 'C0',
  },
  tantalumCapacitorNames: {
    c100m: 'C100M',
    c101m: 'C101M',
  },
  inductorNames: { l1: 'L1' },
  tool: {
    toolId: 1,
    userId: '2363076A-20B1-1012-AE1A-10B7C77332C4',
  },
  oldSliderSteps: 144,
  slider: {
    chebyshevLimit: 47,
    butterworthLimit: 54,
    besselButterworthLimit: 96,
  },
  maxOrder: 10,
  stageLetter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
  ampStatus: {
    prerelease: 1,
    not_recommended_for_new_designs: 4,
    lastTimeBuy: 5,
    obsolete: 6,
  },
  ampRecommendationStatus: {
    recommended: 1,
    marginal: 2,
    notAllowed: 3,
  },
  resistorNoiseBase: 4.07e-9,
  spiceFileType: {
    ACAnalysis: 'AC Analysis',
    TransientAnalysis: 'Transient Analysis',
    NoiseAnalysis: 'Noise Analysis',
  },
  schematicKey: {
    acKey: 'acAnalysis',
    noiseKey: 'noiseAnalysis',
    transientKey: 'transientAnalysis',
  },
  circuitPath: 'circuits/',
  circuitWidget: {
    compSelectCanvasWidget: 'compSelectCanvasWidget',
    toleranceCanvasWidget: 'toleranceCanvasWidget',
    finalCanvasWidget: 'finalCanvasWidget',
  },
  fwCircuits: {
    gain: 'gain-circuit',
    lowPassFirstOrder: 'lowpass-firstorder',
    lowPassFirstOrderGain: 'lowpass-firstorder-gain',
    lowPassSallenKey: 'lowpass-sallenkey',
    lowPassSallenKeyGain: 'lowpass-sallenkey-gain',
    lowPassMultipleFeedback: 'lowpass-multiplefeedback',
    lowPassInductor: 'lowpass-inductor',
    lowPassInductorGain: 'lowpass-inductor-gain',
    highPassFirstOrder: 'highpass-firstorder',
    highPassFirstOrderGain: 'highpass-firstorder-gain',
    highPassSallenKey: 'highpass-sallenkey',
    highPassSallenKeyGain: 'highpass-sallenkey-gain',
    highPassMultipleFeedback: 'highpass-multiplefeedback',
    highPassInductor: 'highpass-inductor',
    highPassInductorGain: 'highpass-inductor-gain',
    bandPassDelyiannisFriendNoPosFB: 'bandpass-multiplefeedback-noposfb',
    bandPassDelyiannisFriendPosFB: 'bandpass-multiplefeedback-posfb',
    bandPassDelyiannisFriendPosFBnoR2: 'bandpass-multiplefeedback-posfbnor2',
    bandPassInductor: 'bandpass-inductor',
    bandPassInductorGain: 'bandpass-inductor-gain',
    referenceCircuit: 'reference-circuit',
    bypassCapacitor: 'bpcap-circuit',
    tantalumCapcacitorPositive: 'tantcap-pos',
    tantalumCapcacitorNegative: 'tantcap-neg',
    spareAmpSingle: 'spare-single',
    spareAmpDual: 'spare-dual',
  },
  spiceCircuitPath: 'assets/data/spice-circuits/',
  spiceFolderDownloadPath: 'SPICE Files',
  fieldTypes: {
    AlphaNumeric: 'ALPHANUMERIC',
    Alphabet: 'ALPHABET',
    Numeric: 'NUMERIC',
    NumericDecimal: 'NUMERICDECIMAL',
    Engineering: 'ENGINEERING',
    Custom: 'CUSTOM',
    AllChars: 'ALLCHARS',
    Scientific: 'SCIENTIFIC',
  },
  fieldCapitlization: {
    UpperCase: 'UPPERCASE',
    LowerCase: 'LOWERCASE',
    FirstChar: 'FIRSTCHAR',
    AllFirstChar: 'ALLFIRSTCHAR',
  },
  evalBoard: {
    fileBase: 'EVAL-FW-{{type}}{{implementation}}{{channel}}',
    mother: 'MOTHER',
    none: '',
    type: {
      lowPass: 'LP',
      highPass: 'HP',
      bandPass: 'BP',
      bandStop: '',
      notch: 'BP',
      gain: 'LP',
    },
    implementation: {
      firstOrder: 'SK',
      sallenKey: 'SK',
      multipleFeedback: 'MFB',
      deliyannisFriend: 'DF',
      inductor: '',
      gain: 'SK',
    },
    channel: {
      one: '1',
      two: '2',
      other: '',
    },
  },
  roundDirection: {
    up: 'up',
    down: 'down',
    closest: 'closest',
  },
  loadErrorCodes: {
    noError: 0,
    generalError: -1,
    invalidPartFound: -2,
    noOpAmps: -3,
  },
  coverImageResource: 'assets/images/PDFDesignFrontPage.jpg',
  enFontResource: 'assets/fonts/arial.ttf',
  jpFontResource: 'assets/fonts/NotoSansJP-Regular.ttf',
  cnFontResource: 'assets/fonts/NotoSansSC-Regular.ttf',
  //spiceSchematicCircuits: {
  //    oneStageACAnalysis: 'acAnalysis1Stage.asc',
  //    twoStageACAnalysis: 'acAnalysis2Stage.asc',
  //    threeStageACAnalysis: 'acAnalysis3Stage.asc',
  //    fourStageACAnalysis: 'acAnalysis4Stage.asc',
  //    fiveStageACAnalysis: 'acAnalysis5Stage.asc',
  //    oneStageNoiseAnalysis: 'noiseAnalysis1Stage.asc',
  //    twoStageNoiseAnalysis: 'noiseAnalysis2Stage.asc',
  //    threeStageNoiseAnalysis: 'noiseAnalysis3Stage.asc',
  //    fourStageNoiseAnalysis: 'noiseAnalysis4Stage.asc',
  //    fiveStageNoiseAnalysis: 'noiseAnalysis5Stage.asc',
  //    oneStageTransientAnalysis: 'transientAnalysis1Stage.asc',
  //    twoStageTransientAnalysis: 'transientAnalysis2Stage.asc',
  //    threeStageTransientAnalysis: 'transientAnalysis3Stage.asc',
  //    fourStageTransientAnalysis: 'transientAnalysis4Stage.asc',
  //    fiveStageTransientAnalysis: 'transientAnalysis5Stage.asc',
  //}
};

export default FilterConstants;
